module.exports = __webpack_public_path__ + "img/tooth-light.369c0153.svg";